export function applyPropertyControls(Component, controls) {
    if (isControlComponent(Component)) {
        Component.propertyControls = {
            ...Component.propertyControls,
            ...controls
        };
    }
    else {
        Component.propertyControls =
            controls;
    }
}
// type KeyFromVal<T, V> = {
// 	[K in keyof T]: V extends T[K] ? K : never;
// }[keyof T];
// we assume the type to be an object literal with string values
// , should also work with number or symbol
// type Inverse<M extends Record<string, string>> = {
// 	[K in M[keyof M]]: KeyFromVal<M, K>;
// };
export var ControlType;
(function (ControlType) {
    ControlType["Boolean"] = "boolean";
    ControlType["Enum"] = "enum";
    ControlType["Number"] = "number";
    ControlType["String"] = "string";
    ControlType["FusedNumber"] = "fusednumber";
    ControlType["Color"] = "color";
    ControlType["Image"] = "image";
    ControlType["File"] = "file";
    ControlType["ComponentInstance"] = "componentinstance";
    ControlType["Array"] = "array";
    ControlType["Object"] = "object";
    ControlType["Date"] = "date";
    ControlType["Hidden"] = "hidden";
})(ControlType || (ControlType = {}));
// export const is: <K extends keyof Inverse<typeof ControlType>>(
// 	val: K
// ) => Inverse<typeof ControlType>[K];
// export function is<K extends keyof Inverse<typeof ControlType>>(val: K) {
// 	ControlType[val];
// }
export function isControlComponent(component) {
    return component.propertyControls != null;
}
//# sourceMappingURL=property-controls.js.map